export default "__VITE_ASSET__DPMBmhpE__"